import { useMemo } from "react"
import { Box, Grid, Stack, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { Repeat } from "lib/@components/repeat"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import { ExplorerItem } from "./explorer-item"

export function CategoryList() {
    const { category } = useBoundContext()
    const items = useMemo(buildItems, [category?.children, category?.tasks])

    return (
        <If value={items.length > 0}>
            <Box sx={{ mb: 4 }}>
                <Typography variant="subtitle1" sx={{ mb: 2 }}>
                    Items
                </Typography>

                <Grid container spacing={2}>
                    <Repeat list={items} item={<ExplorerItem />} />
                </Grid>
            </Box>

            <Else>
                <Stack
                    alignItems="center"
                    justifyContent="center"
                    sx={{
                        mb: 4,
                        py: 6,
                        px: 3,
                        bgcolor: "background.neutral",
                        borderRadius: 1,
                        border: (theme) => `1px dashed ${theme.palette.divider}`,
                    }}
                >
                    <Iconify
                        icon="eva:file-text-outline"
                        sx={{ width: 48, height: 48, color: "text.disabled", mb: 2 }}
                    />
                    <Typography variant="body1" color="text.secondary">
                        No items found
                    </Typography>
                </Stack>
            </Else>
        </If>
    )

    function buildItems() {
        const children = [...(category?.children || [])].sort(sortChildren)
        const tasks = [...(category?.tasks || [])]
            .sort((a, b) => (a.heading || "").localeCompare(b.heading || ""))
            .map((task) => ({ ...task, __isTask: true }))
        return [...children, ...tasks]
    }

    function sortChildren(a, b) {
        const aIsFile = a.type === "file"
        const bIsFile = b.type === "file"

        if (aIsFile !== bIsFile) {
            return aIsFile ? 1 : -1
        }
        return (a.name || "").localeCompare(b.name || "")
    }
}
